<template>
  <sider-subpage-elements
    :items="projectsArray"
    :items-disabled="isModifySnappingActive || (isMapView && !isProjectLayersFetched)"
    :items-tooltip="changeProjectTooltip"
    :active-value="isMapView ? projectId : undefined"
    :is-loading="isLoading"
    @change="openMap"
  />
</template>

<script>
import SiderSubpageElements from '@/components/SiderSubpageElements';

import { get, sync, call } from 'vuex-pathify';

export default {
  name: 'SiderMapSection',
  components: {
    SiderSubpageElements,
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    currentUserId: get('users/currentUser@id'),
    project: sync('layers/project'),
    projectId: get('layers/project@id'),
    projects: get('layers/projects'),

    isProjectLayersFetched: sync('sidebar/isProjectLayersFetched'),
    isModifySnappingActive: get('edit/isModifySnappingActive'),
    changeProjectTooltip() {
      return this.isModifySnappingActive
        ? this.$i18n.t('button.toChangeProject', { reason: this.$i18n.t('button.turnOffEditing') })
        : undefined;
    },
    isMapView() {
      return this.$route.path?.split('/')[1] === 'map';
    },
    projectsArray() {
      const lastUsedProjectsIds = JSON.parse(localStorage.getItem('last-used-projects') || '[]') || [];
      const order = ['default', 'predefined', 'owner', 'shared'];

      return [...this.$_objectToArray(this.projects)]
        .map(item => {
          const isOwner = this.currentUserId === item.owner;
          const role = item['role'] ? item['role'] : isOwner ? 'owner' : 'shared';
          return {
            id: item.id,
            name: item.name,
            role,
          };
        })
        .sort((a, b) => {
          const aIndex = lastUsedProjectsIds.indexOf(a.id);
          const bIndex = lastUsedProjectsIds.indexOf(b.id);
          if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
          else if (aIndex !== -1) return -1;
          else if (bIndex !== -1) return 1;
          else if (order.indexOf(a.role) - order.indexOf(b.role) === 0) return a['name'].localeCompare(b['name']);
          return order.indexOf(a.role) - order.indexOf(b.role);
        });
    },
  },
  methods: {
    getProjects: call('layers/getProjects'),
    openMap(projectId) {
      if (this.isMapView) {
        if (projectId === this.projectId) return;
        const project = JSON.parse(JSON.stringify(this.projects[projectId]));
        this.$root.$emit('projectChanged', { e: project, withRouterParse: true });
      } else {
        this.$router.push({ name: 'map', query: { project: projectId } });
      }
    },
    async parseProjects() {
      if (Object.keys(this.projects).length) return (this.isLoading = false);
      this.isLoading = true;
      try {
        await this.getProjects();
      } catch (error) {
        console.error();
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.parseProjects();
  },
};
</script>
